import { gql } from '@apollo/client';

export const disassociateAccountVehicle = gql`
  mutation disassociateAccountVehicle($input: DisassociateAccountVehicleInput!) {
    disassociateAccountVehicle(input: $input) {
      success
    }
  }
`;
